<div class="flex flex-col">
    <div class="status font-bold text-xs w">{{ 'EXTERN_STATE' | translate }}</div>
    <div *ngIf="!loading_statuses" class="list flex h-10">
        <div class="value flex scroll-hide justify-start gap-2">
            <div class="justify-center items-center self-center mr-4 flex" *ngIf="archived"><mat-icon class="!flex text-[1.8rem] mt-[-0.1rem] text-tw-secondary" [matTooltip]=" 'ARCHIVED' | translate ">archive</mat-icon></div>
            <ng-container *ngFor="let proofreading of proofreadings">
                <div class="flex flex-row justify-start items-center gap-2 last:mr-0" [ngClass]="{'!gap-1': spacingConditions}">
                    <div flow [ngClass]="{'text-xs': spacingConditions}" class="text-xs">{{ proofreading.flow | translate }}</div>
                    <div [ngClass]="getSlugText(proofreading.state.slug, false, proofreading)"><span class="whitespace-nowrap italic" [ngClass]="{'text-sm': spacingConditions}">{{ ("EXTERN.DASHBOARD." + getSlugText(proofreading.state.slug, false, proofreading)) | uppercase | translate }}</span></div>
                    <div class="boxes-container flex flex-row justify-start items-center gap-2">
                        <!--[ngClass]="archived ? 'disabled' : ''"-->
                        <a [routerLink]="'/splitview/' + proofreading._id" class="version-box" [ngClass]="{'w-[1.75em]': spacingConditions}">
                            <div class="flex leading-[2em]" [ngClass]="{'leading-[1.75em]': spacingConditions}"> {{ getPrefixRelecture(proofreading.flow).short }}{{ proofreading?.relecture || 0 }} </div>
                        </a>
                        <a *ngIf="!isClient() && proofreading.intern" [routerLink]="'/splitview/intern/' + proofreading._id" class="version-box" [ngClass]="{'w-[1.75em]': spacingConditions}">
                            <div class="flex leading-[2em]" [ngClass]="{'leading-[1.75em]': spacingConditions}"> v{{ proofreading?.intern?.viewer?.version || 0 }} </div>
                        </a>
                    </div>
                </div>
            </ng-container>
        </div>
        <ng-container *ngIf="isCPP() && project && available_flows.length && !archived && allowAddingFlows && !isOldProject">
            <button mat-icon-button class="!border-tw-primary text-tw-primary ml-16" (click)="openCreateProofreadingModal()">
                <mat-icon>add</mat-icon>
            </button>
        </ng-container>
    </div>
    <ng-container *ngIf="loading_statuses">
        <mat-option>
            <mat-spinner style="margin: auto;" [diameter]="20"></mat-spinner>
        </mat-option>
    </ng-container>
</div>